<template>
	<div v-if="!_gHlp.isEmpty(proposal) && !_gHlp.isEmpty(customer)">
		<b-row>
			<b-col cols="12">
				<CcrisMainInfo :proposal="proposal" />
			</b-col>
			<b-col cols="12">
				<CcrisTrackMiniCards :proposal="proposal" :customer_ctos="customer_ctos" />
			</b-col>
		</b-row>

		<el-collapse class="border-0">
			<el-collapse-item name="1" class="my-3">
				<div slot="title" class="collapse-header w-100">
					<div class="d-flex align-items-center justify-content-between">
						<h3 class="px-3 mb-0">Product Application</h3>
						<el-dropdown trigger="click" v-if="is_editable">
							<el-button type="primary" size="mini" icon="fa fa-plus" class="el-dropdown-link float-right mr-3"
								@click.stop="" round> Add Product</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="(product, index) in productsToApply" :key="index" class="px-3"
									@click.native="openApplicationModal(product.name)">
									<span v-html="product.icon" class="mr-1"></span>
									{{ product.name }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
				<ProductApplication :psal_id="proposal.psal_id" :is_editable="is_editable" />
			</el-collapse-item>
			<el-collapse-item name="2" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">CCRIS Items</h3>
				</div>
				<CcrisItems :psal_id="proposal.psal_id" :psal_invinity_id="proposal.psal_invinity_id" :is_editable="is_editable"/>
			</el-collapse-item>
			<el-collapse-item name="3" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">Additional Commitments</h3>
				</div>
				<AdditionalCommitments :psal_id="proposal.psal_id" :psal_invinity_id="proposal.psal_invinity_id" :is_editable="is_editable" />
			</el-collapse-item>
			<el-collapse-item name="4" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">Fees And Charges</h3>
				</div>
				<FeesAndCharges :psal_id="proposal.psal_id" :psal_invinity_id="proposal.psal_invinity_id" :is_editable="is_editable" />
			</el-collapse-item>
			<el-collapse-item name="5" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">KYC 2 (Understand Your Customer)</h3>
				</div>
				<KYCQuestion :psal_id="proposal.psal_id" :is_editable="is_editable" :proposal="proposal"/>
			</el-collapse-item>
			<el-collapse-item name="6" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">Merchant Settlements</h3>
				</div>
				<MerchantSettlements :psal_id="proposal.psal_id" :psal_invinity_id="proposal.psal_invinity_id" :is_editable="is_editable"/>
			</el-collapse-item>
			<el-collapse-item name="7" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">Invinity Credit Settlement</h3>
				</div>
				<InvinityCreditSettlement :psal_id="proposal.psal_id" :psal_invinity_id="proposal.psal_invinity_id" :is_editable="is_editable"/>
			</el-collapse-item>
			<el-collapse-item name="8" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">Proposed Repayment Sources</h3>
				</div>
				<RepaymentSources :psal_id="proposal.psal_id" :psal_invinity_id="proposal.psal_invinity_id" :is_editable="is_editable"/>
			</el-collapse-item>
			<el-collapse-item name="9" class="my-3">
				<div slot="title" class="collapse-header">
					<h3 class="px-3 mb-0">Customer Documents</h3>
				</div>
				<CustomerDocuments :proposal="proposal" :is_editable="is_editable" />
			</el-collapse-item>
		</el-collapse>

		<b-row class="mt-5 pb-3">
			<b-col cols="12" class="text-center">
				<el-button name="perv-act" class="bg-danger py-3 text-white" :loading="is_submit_loading" @click="prevApproval"
					v-if="showApprovalButton && !_gHlp.isEmpty(_gHlp.getValue(proposal,'latest_approval.next_action.pset_prev_code'))">
					{{ _gHlp.getValue(proposal,'latest_approval.next_action.pset_prev_btn_label') }}
				</el-button>
				<el-button name="next-act" class="bg-success py-3 text-white" :loading="is_submit_loading" @click="directApproval"
					v-if="showDirectApprovalButton">
					Direct Approve as Proposal
				</el-button>
        <el-button name="next-act" class="bg-primary py-3 text-white" :loading="is_submit_loading" @click="nextApproval"
					v-if="showApprovalButton && !_gHlp.isEmpty(_gHlp.getValue(proposal,'latest_approval.next_action.pset_next_code'))">
					{{ _gHlp.getValue(proposal,'latest_approval.next_action.pset_next_btn_label') }}
				</el-button>
				<el-button name="next-act" class="bg-success py-3 text-white" :loading="is_submit_loading" @click="resubmitToSync"
					v-if="showConvertLmsButton">
					Resubmit Credit Approval
				</el-button>
			</b-col>
		</b-row>


		<PropertyApplicationModal :show_property_application.sync="modals.show_property_application" :proposal="proposal" />
		<MortgageApplicationModal :show_mortgage_application.sync="modals.show_mortgage_application" :proposal="proposal" />
		<PersonalLoanApplicationModal :show_personal_loan_application.sync="modals.show_personal_loan_application"
			:proposal="proposal" />
		<RefinancingApplicationModal :show_refinancing_application.sync="modals.show_refinancing_application"
			:proposal="proposal" />
		<InsuranceApplicationModal :show_insurance_application.sync="modals.show_insurance_application"
			:proposal="proposal" />
		<OtherLoanApplicationModal :show_other_loan_application.sync="modals.show_other_loan_application"
			:proposal="proposal" />
	</div>
</template>
<script>
import { Collapse, CollapseItem, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import CcrisMainInfo from '@/views/InitialProposal/SubDetails/SectionItems/CcrisMainInfo'
import CcrisTrackMiniCards from '@/views/InitialProposal/SubDetails/SectionItems/CcrisTrackMiniCards'
import ProductApplication from '@/views/InitialProposal/SubDetails/SectionItems/ProductApplication'
import CcrisItems from '@/views/InitialProposal/SubDetails/SectionItems/CcrisItems'
import AdditionalCommitments from '@/views/InitialProposal/SubDetails/SectionItems/AdditionalCommitments'
import FeesAndCharges from '@/views/InitialProposal/SubDetails/SectionItems/FeesAndCharges'
import MerchantSettlements from '@/views/InitialProposal/SubDetails/SectionItems/MerchantSettlements'
import InvinityCreditSettlement from '@/views/InitialProposal/SubDetails/SectionItems/InvinityCreditSettlement'
import RepaymentSources from '@/views/InitialProposal/SubDetails/SectionItems/RepaymentSources'
import KYCQuestion from '@/views/InitialProposal/SubDetails/SectionItems/KYCQuestion'
import CustomerDocuments from '@/views/InitialProposal/SubDetails/SectionItems/CustomerDocuments'

import PropertyApplicationModal from '@/views/InitialProposal/Modals/PropertyApplicationModal'
import MortgageApplicationModal from '@/views/InitialProposal/Modals/MortgageApplicationModal'
import PersonalLoanApplicationModal from '@/views/InitialProposal/Modals/PersonalLoanApplicationModal'
import RefinancingApplicationModal from '@/views/InitialProposal/Modals/RefinancingApplicationModal'
import OtherLoanApplicationModal from '@/views/InitialProposal/Modals/OtherLoanApplicationModal'
import InsuranceApplicationModal from '@/views/InitialProposal/Modals/InsuranceApplicationModal'

import { IP_APPROVED_STATUSES } from '@/assets/js/status.js'
import { mapActions, mapState } from 'pinia'
import { useInitialProposalStore } from '@/stores/initialProposalStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useInvinityStore } from '@/stores/invinityStore'
import { useConfigStore } from '@/stores/configStore'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
	props: ['proposal', 'banks', 'customer', 'customer_ctos'],
	components: {
		CcrisMainInfo,
		CcrisTrackMiniCards,
		ProductApplication,
		CcrisItems,
		AdditionalCommitments,
		MerchantSettlements,
		FeesAndCharges,
		KYCQuestion,
		InvinityCreditSettlement,
		PropertyApplicationModal,
		MortgageApplicationModal,
		PersonalLoanApplicationModal,
		RefinancingApplicationModal,
		OtherLoanApplicationModal,
		InsuranceApplicationModal,
		RepaymentSources,
		CustomerDocuments,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
	},
	data() {
		return {
			IP_APPROVED_STATUSES: IP_APPROVED_STATUSES,
			is_submit_loading: false,
			showProposalDetailsDrawer: false,
			showsProps: {
				showCcrisTrack: true,
				showProposalTab: false,
			},
			productsToApply: [
				{
					icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#A4B0C0" d="M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm-8 18H5v-5.586l3-3 3 3V20zm8 0h-6v-4a.999.999 0 0 0 .707-1.707L9 9.586V4h10v16z"/><path fill="#A4B0C0" d="M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 1h2v2H7z"/></svg>',
					name: 'Property'
				},
				{
					icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 576 512"><path fill="#A4B0C0" d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24zM352 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-64z"/></svg>',
					name: 'Mortgage'
				},
				{
					icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 576 512"><path fill="#A4B0C0" d="M312 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-6-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm256.2 312.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z"/></svg>',
					name: 'Personal Loan'
				},
				{
					icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 16 16"><path fill="#A4B0C0" d="M12.1.3A1.5 1.5 0 0 1 14 1.8V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9A1.5 1.5 0 0 1 1.4 3L12.1.3zM5.6 3H13V1.8a.5.5 0 0 0-.6-.5zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>',
					name: 'Refinance'
				},
				{
					icon: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shield-plus" viewBox="0 0 16 16"><path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56"/><path d="M8 4.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V9a.5.5 0 0 1-1 0V7.5H6a.5.5 0 0 1 0-1h1.5V5a.5.5 0 0 1 .5-.5"/></svg>',
					name: 'Insurance'
				},
				{
					icon: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-fill" viewBox="0 0 16 16"><path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z"/></svg>',
					name: 'Other Loan'
				},
			],
			modals: {
				show_property_application: false,
				show_mortgage_application: false,
				show_personal_loan_application: false,
				show_credit_card_application: false,
				show_other_loan_application: false,
				show_insurance_application: false,
				show_refinancing_application: false,
			}
		}
	},
	computed: {
		is_editable() {
			return !IP_APPROVED_STATUSES.includes(this.proposal.psal_main_status)
		},
		showDirectApprovalButton() {
			if(['submit_to_ssa_mgr'].includes(this.proposal.psal_approval_code) && this.proposal.invinity_commitments.length == 0 && (_gHlp.checkAccess(['role_admin', 'role_corporate', 'role_super_admin', 'role_it_admin', 'role_sales_manager', 'role_sales_advisor_manager', 'role_sales_support_manager']))) {
				return true;
			}
			return false;
		},
		showApprovalButton() {
			//IS SATTUS SUBMITED OR APPEAL TO CREDITE MGR / HEAD PROCESS MOVE TO LMS SYSTEM
			if (['submit_to_credit_mgr', 'appeal_to_credit_head'].includes(this.proposal.psal_approval_code)) {
				return false;
			}

			//IF ALREADY PENDING ACCEPTANCE
			if (['pending_accept', 'accepted'].includes(this.proposal.psal_approval_code)) {
				return false;
			}
			//IF DRAFT SHOW FOR UPLINE & CREATOR
			if (
				(['draft', 'reject_by_ssa_mgr', 'declined'].includes(this.proposal.psal_approval_code) || _gHlp.isEmpty(this.proposal.psal_approval_code)) &&
				// ((!_gHlp.isEmpty(this.proposal.psal_created_by_detail.upline_user) && (_gAuth.activeUserId() === this.proposal.psal_created_by_detail.upline_user.id)) || (_gAuth.activeUserId() === this.proposal.psal_created_by))
				((!_gHlp.isEmpty(this.proposal.customer_detail) && ((_gAuth.activeUserId() === this.proposal.customer_detail.ssa_id) || (_gAuth.activeUserId() === this.proposal.customer_detail.se_id))) || (_gAuth.activeUserId() === this.proposal.psal_created_by) || _gHlp.checkAccess(['role_admin','role_admin_support','role_super_admin']))
			) {
				return true;

				//ELSE SHOW FOR ALL APPROVER EXCEPT UPLINE & CREATOR	
			} else if (
				((!_gHlp.isEmpty(_gHlp.getValue(this.proposal,'latest_approval.next_action.pset_access_user_ids')) && this.arrayOfUserIds.includes(_gAuth.activeUserId()))
				&& !((_gAuth.activeUserId() === this.proposal.psal_submited_ssa_by) || (_gAuth.activeUserId() === this.proposal.psal_created_by))) || _gHlp.checkAccess(['role_admin','role_admin_support','role_super_admin'])
			) {
				return true;
			}

			return false;
		},
		showConvertLmsButton(){
			if (['submit_to_credit_mgr', 'appeal_to_credit_head','pending_accept', 'accepted'].includes(this.proposal.psal_approval_code) && _gHlp.isEmpty(this.proposal.psal_invinity_id) && this.proposal.invinity_commitments.length > 0) {
				return true;
			}
			return false;
		},
		arrayOfUserIds() {
			let rawIds = _gHlp.getValue(this.proposal,'latest_approval.next_action.pset_access_user_ids',[])
			if (_gHlp.isEmpty(rawIds)) return [];
			let ids = rawIds.flatMap((x) => parseInt(x));

			//GRANT FOR ADMIN
			if(_gHlp.checkAccess(['role_admin','role_admin_support','role_super_admin'])){
				ids.push(_gAuth.activeUserId())
			}

			return ids;
		}
	},
	methods: {
		...mapActions(useNotificationStore, ['createNotification','fetchEmailTemplate','fetchNotificationTemplate']),
		...mapActions(useInitialProposalStore, ['getProposal','updateProposal','sendApprovalEmailAndBell']),
		...mapActions(useInvinityStore, ['exportProposalToLMS']),
		...mapActions(useMessagingStore, ['sendEmail']),
		prevApproval() {
			let params = {
				psal_customer_id: this.proposal.psal_customer_id,
				psal_approval_code: _gHlp.getValue(this.proposal,'latest_approval.next_action.pset_prev_code')
			}
			let success_message = _gHlp.getValue(this.proposal,'latest_approval.next_action.pset_prev_btn_label','rejected');
			this.editProposal(params, success_message);
		},
		async nextApproval() {
			let params = {
				psal_customer_id: this.proposal.psal_customer_id,
				psal_approval_code: _gHlp.getValue(this.proposal,'latest_approval.next_action.pset_next_code'),
				psal_refresh_customer: true
			}
			let success_message = _gHlp.getValue(this.proposal,'latest_approval.next_action.pset_next_btn_label','submitted')
      //await this.sendProposalSubmitEmail(this.proposal.psal_id, this.proposal.customer_detail.name);

			this.editProposal(params, success_message);
		},
		directApproval() {
			let params = {
				psal_customer_id: this.proposal.psal_customer_id,
				psal_approval_code: 'pending_accept',
				psal_refresh_customer: true
			}
			let success_message = 'submitted';
			this.editProposal(params, success_message);
		},
		async editProposal(params, success_message = 'submitted') {
			this.is_submit_loading = true
			let invinity = null;
			if (['submit_to_credit_mgr', 'appeal_to_credit_head'].includes(params.psal_approval_code)) {
				//update approval status to sas first
				await this.updateProposal(this.proposal.psal_id,params);
				//then sync to lms so lms can have nixt approver for set credit manager
				let resp = await this.exportProposalToLMS(this.proposal.psal_customer_id, this.proposal.psal_id, {credit_report_id:_gHlp.getValue(this.customer_ctos,'credit_report_id',null)});
				if(!_gHlp.isEmpty(resp)){
					_gNotif.notifySuccess('Proposal : Success Submited to lms', 1500, 'success');
					invinity = _gHlp.getValue(resp,'data')
				}
      } else {
				await this.updateProposal(this.proposal.psal_id,params);
				_gNotif.notifySuccess('<b>Proposal </b> - Successfully ' + success_message + '.')
			}
			initialProposalEventBus.$emit('refresh-proposal-detail')
			this.is_submit_loading = false;
		},
		async resubmitToSync(){
			this.is_submit_loading = true
			let resp = await this.exportProposalToLMS(this.proposal.psal_customer_id, this.proposal.psal_id, {credit_report_id:_gHlp.getValue(this.customer_ctos,'credit_report_id',null)})
			if(!_gHlp.isEmpty(resp)){
				_gNotif.notifySuccess('Proposal : Success Resubmited to lms', 1500, 'success');
				initialProposalEventBus.$emit('refresh-proposal-detail')
			}
			this.is_submit_loading = false;
		},
		closeDrawerLms() {
			this.is_submit_loading = false;
		},
		openApplicationModal(productSelected) {
			// Close all modals
			this.modals.show_property_application = false;
			this.modals.show_mortgage_application = false;
			this.modals.show_personal_loan_application = false;
			this.modals.show_credit_card_application = false;
			this.modals.show_other_loan_application = false;
			this.modals.show_insurance_application = false;
			this.modals.show_refinancing_application = false;
			// Open the selected modal
			switch (productSelected) {
				case 'Property':
					this.modals.show_property_application = true;
					break;
				case 'Mortgage':
					this.modals.show_mortgage_application = true;
					break;
				case 'Personal Loan':
					this.modals.show_personal_loan_application = true;
					break;
				case 'Insurance':
					this.modals.show_insurance_application = true;
					break;
				case 'Refinance':
					this.modals.show_refinancing_application = true;
					break;
				case 'Other Loan':
					this.modals.show_other_loan_application = true;
					break;
			}
		}
	}
}
</script>